// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__frQCo","toggleWrap":"styles_toggleWrap__3GyRJ","content":"styles_content__2Btzk","selectAreaCode":"styles_selectAreaCode__27nwZ"};